import React from "react";

import styles from "../editor.module.scss";

const PlaceHolderPlugin = () => {
	return (
		<div className={styles.editorPlaceholder}>
			Please enter some text...
		</div>
	);
};

export default PlaceHolderPlugin;
